/*! LQ NameSpace | Copyright 2015 Loto Quebec Inc. */
/*global jQuery,lq,console*/
/*jshint -W030*/
; (function ($, document, window, lq) {
	'use strict';
	
	var $W = $(window);
	var iframeLoaded = false;
	var isStateAuthor = window.lq.configs.isStateAuthor;

	lq.video = (function(){

		var ytPlayer = [];
		var ambiancePlayer = [];

		/**
		 * Init YouTube player with YouTubeIFrameAPI
		 * Apply to all element with a class "fn-youtube-video"
		 * Use required attributes:
		 * data-width - To set the width of the video
		 * data-height - To set the height of the video
		 * data-video-id - To set the ID of the youtube video to play
		 *
		 * Use optional attributes:
		 * data-player-controls with value of 0, 1 or 2 (see https://developers.google.com/youtube/player_parameters#controls) default is 1
		 * data-player-showinfo with value of 0 or 1 (see https://developers.google.com/youtube/player_parameters#showinfo) default is 0
		 * data-player-modestbranding with value of 0 or 1 (see https://developers.google.com/youtube/player_parameters#modestbranding) default is 0
		 * data-player-related-video with value of 0 or 1 (see https://developers.google.com/youtube/player_parameters#rel) default is 0
		 * data-player-mode with value of opaque or ? (see https://developers.google.com/youtube/player_parameters#wmod) default is opaque
		 * data-player-autoplay with value of 0 or 1 (see https://developers.google.com/youtube/player_parameters#autoplay) default is 0
		 *
		 * @param {string|HTMLElement} [limitContext=null] jQuery selector to limit search in. Default = null
		 * @function handleComponentTabs
		 * @memberOf lq.video
		 */
		function initPlayers(limitContext) {
			limitContext = (limitContext || null);

			var $limit = lq.support.safe(limitContext),
					$allVideos = ($limit.is('.fn-youtube-video') ? $limit : $('.fn-youtube-video', limitContext));

			var pauseAllAmbiance = function() {
				if(!lq.support.device) {
					$(lq.video.ambiancePlayer).each(function() {
						this.pauseVideo();
					});
				}
			};

			$allVideos.each(function() {
				var $self = $(this),
						$p = $self.parent(),
						$contentText = $self.next('.fn-video-text'),
						$sizer = $self.parents('.media-bg-with-content.type-video'),
						rH = Math.max($sizer.height(), ($p.width() * (9/16))),
						rW = (rH / 9) * 16,
						pauseFlag = false,
						vid = {
							width: rW,
							height: rH,
							videoId: $self.data('video-id'),
							events: {
								'onReady': function() {
									if(vid.playerVars.loop || $self.data('ambiance')) {
										//lq.console.log('set loop to true');
										player.setLoop(true);
									}
									if($self.data('ambiance')) {
										var $iframe = $p.find('iframe'),
												elemPos;
										// set min-width and min-height on iframe video wrapper
										$wrapper.css({'min-width': rW + 'px', 'min-height': rH + 'px'});
										// If video is in cued instead of buffering or playing, the device can't automatically play it. Hide the video and alternate background image will be show.
										if(player.getPlayerState() == YT.PlayerState.CUED) {
											$iframe.hide();
										} else {
											$W.trigger('resize');
										}
										// Mute ambiance video
										player.mute();
									}

								},
								'onPlaybackQualityChange': function() {/* Can add code for onPlaybackQualityChange here */},
								'onError': function() {
									var $iframe = $p.find('iframe');
									$iframe.hide();
								},
								'onStateChange': function (e) {
									//lq.console.log(e.data);
									if(!$self.data('ambiance')) {
										// track when user clicks to Play
										if (e.data == YT.PlayerState.PLAYING) {
											// Pause other videos on page (except ambiance video)
											if(!lq.support.device) {
												$(lq.video.ytPlayer).each(function () {
													if (this != player) {
														if (this.getPlayerState() == 1) {
															//lq.console.log({isAmbianceVideo: false, p: player});
															this.pauseVideo();
														}
													}
												});
											}

											$contentText.fadeOut(400);

											pauseFlag = true;
											//lq.ga.trackEvent('YoutubeVideo/Bouton', 'Clic', 'Play/' + $self.data('video-id'));
										}
										// track when user clicks to Pause
										if (e.data == YT.PlayerState.PAUSED && pauseFlag) {
											$contentText.fadeIn(400);
											pauseFlag = false;
											//lq.ga.trackEvent('YoutubeVideo/Bouton', 'Clic', 'Paused/' + $self.data('video-id'));
										}
										// track when video ends
										if (e.data == YT.PlayerState.ENDED) {
											$contentText.fadeIn(400);
											pauseFlag = false;
											//lq.ga.trackEvent('YoutubeVideo', 'Evenement', 'Termine/' + $self.data('video-id'));
										}
									}
								}
							},
							playerVars: {
								autoplay: lq.utils.getDataValue($self, 'player-autoplay', 0),
								controls: lq.utils.getDataValue($self, 'player-controls', 1),
								showinfo: lq.utils.getDataValue($self, 'player-showinfo', 0),
								loop: lq.utils.getDataValue($self, 'player-loop', 0),
								modestbranding: lq.utils.getDataValue($self, 'player-modestbranding', 0),
								rel: lq.utils.getDataValue($self, 'player-related-video', 0),
								wmode: lq.utils.getDataValue($self, 'player-mode', "opaque")
							}
						},
						// Récupère le ID d'élément ou en génère un unique dans le cas ou il n'y en a pas
						selfId = $self.prop('id') || lq.utils.uId('_youtube_'),
						player,
						$wrapper,
						$btn,
					isResponsive = $self.parent().hasClass('embed-responsive');
				//$sizer = $sizer.add($p);

				if(vid.playerVars.loop || $self.data('ambiance')) {
					// Video looping, require a playlist id. Use the same ID as the video.
					vid.playerVars.listType = "playlist";
					vid.playerVars.playlist = [vid.videoId];

					// data ambiance is for background video. We need to force no controls and modest branding.
					if($self.data('ambiance')) {
						vid.playerVars.controls = 0;
						vid.playerVars.autoplay = 1;
						vid.playerVars.modestbranding = 1;
						vid.playerVars.loop = 1;

						// wrap player inside a container for background positioning
						$wrapper = $('<div class="yt-ambiance-video' + ((isResponsive) ? ' embed-responsive-item' : '') + '" style="background-image:' + ($self.data('ambiance-bg-image') ? 'url(' + $self.data('ambiance-bg-image') + ')' : 'none') + '"/>');
						//$wrapper.css({'width': '100%'});
						$self.wrap($wrapper);
						$wrapper = $self.parent();
						$btn = $('<button class="yt-play-pause" type="button">' + lq.i18n.get('playPause') + '</button>');
						$wrapper.prepend($btn);

						$btn.on('click', function () {
							var state = player.getPlayerState();
							player[(state != 1 ? 'play' : 'pause') + 'Video']();
							/*if($self.data('elementToPlayPause')) {
								$self.data('player-paused', (state == 1));
								$self.data('elementToPlayPause').trigger('playPause');
							}*/
							$btn[(state == 1 ? 'add' : 'remove') + 'Class']('paused');
						});
						if(lq.support.device){
							$btn.hide();
						}
					}
				}
				$W.on('resize', function() {

					//lq.console.log('window resize...');
					var $iframe = $p.find('iframe'),
							rH = Math.max($sizer.height(), ($p.width() * (9/16))),
							rW = (rH / 9) * 16,
							rT = ($wrapper && $wrapper.css) ? parseFloat($wrapper.css('padding-top')) : 0,
						elemPos;
					//lq.console.log($wrapper, $wrapper.css('padding-top'));

					$iframe.attr('width', rW)
							.attr('height', rH);
					if($self.data('ambiance')) {
						if(lq.viewport.is('<=medium')) {
							$iframe.hide();
							if(!lq.support.device){
								if($.isFunction(player.playVideo)){
									player.playVideo();									
								}
							}
						} else {
							if(!lq.support.device){
								$iframe.show();
								if($.isFunction(player.playVideo)){
									player.playVideo();									
								}
							}
						}
						$wrapper.css({'min-width': rW + 'px', 'min-height': rH + 'px'});
						elemPos = {
							'top': (rT * -1),
								'margin-bottom': (rT * -1)
						};
						$iframe.css(elemPos).next().css({'top': (rT * -1) + 'px'});
					}
				});
				//lq.console.log(['initPlayers->vid is', vid]);
				// S'assure que l'élément à le id qui sera associé au player
				$self.prop('id', selfId);
				// Init YouTube Player instance
				player = new YT.Player(selfId, vid);

				player.playMe = function() {
					$p.find('iframe').attr('width', $p.width())
							.attr('height', $p.width() * (9/16));
					if(!lq.support.device){
						if($.isFunction(player.playVideo)){
							player.playVideo();									
						}
					}
				};

				if(!$self.data('ambiance')) {
					ytPlayer.push(player);
				} else {
					ambiancePlayer.push(player);
				}
				$self.data('ytPlayer', player);
				//lq.console.log(player);
			});
		}

		/**
		 * Test if there is element with the class fn-youtube-video in the page
		 * @returns {boolean}
		 */
		function isYoutubeInPage() {
			return !!document.querySelector('.fn-youtube-video');
		}

		function playVideoAndHideOverlay(overlay) {
			loadApi();
			// Hide the overlay
			overlay.querySelector('.video-consent-overlay').style.display = 'none';
		}

		function setPositiveConsentStatusForVendor(vendorId) {
			// Get all the vendor purposes
			var purposes = Didomi.getVendorById(vendorId).purposeIds;
			// Create a "transaction"...
			var transaction = Didomi.openTransaction();
			// ... enable the vendor
			transaction.enableVendor(vendorId);
			// ... and all his purposes
			transaction.enablePurposes(...purposes);
			// update the new status using "commit"
			transaction.commit();
		}

		function loadApi() {
			//lq.console.log('load YouTube API...');
			if(isYoutubeInPage()) {
					// YouTube api ready callback

					if(iframeLoaded) {
						document.querySelectorAll(".youtube-container").forEach(function (overlay) {
							overlay.querySelector(".fn-youtube-video").style.display = "block";
							var iframe = overlay.querySelector("iframe[data-src]");
							if (iframe) {
								var src = iframe.getAttribute("data-src");
								iframe.setAttribute("src", src);
								overlay.querySelector(".video-consent-overlay").style.display = "none";
							}
						});
					} else {
						window.onYouTubeIframeAPIReady = function (event) {
							initPlayers();
						};

						//lq.console.log('load api');
						// This code loads the IFrame Player API code asynchronously
						var tag = document.createElement('script');
						tag.src = "https://www.youtube.com/iframe_api";
						var firstScriptTag = document.getElementsByTagName('script')[0];
						firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
						iframeLoaded = true;
					}
			} else {
					//lq.console.log('No video in page, no need of YouTube API');
			}        		
		}

		function hidePlayerVideo() {
			document.querySelectorAll(".youtube-container").forEach(function (overlay) {
				var iframe = overlay.querySelector("iframe[src]");
				if (iframe) {
					var src = iframe.getAttribute("src");
					iframe.setAttribute("data-src", src);
					iframe.removeAttribute("src")
					overlay.querySelector(".fn-youtube-video").style.display = "none";
					overlay.querySelector(".video-consent-overlay").style.display = "flex";
				}
			});
		}


		// Accès public aux méthodes
		return{
			loadDidomi: function (){
				if(isStateAuthor){
					document.querySelectorAll('.youtube-container').forEach(function(video) {
						// call our play & hide function
						playVideoAndHideOverlay(video);
					})
				}else{
					// Create the "didomiOnReady" listener
					window.didomiOnReady = window.didomiOnReady || [];
					window.didomiOnReady.push(function (Didomi) {
						// Subscribe to the vendor status : It triggers the listener each time the status is changed for this vendor.
						Didomi.getObservableOnUserConsentStatusForVendor('c:youtube-xhBVKfkq')
						.subscribe(function (consentStatus) {
							// Check if the "consentStatus" is true (eg. the user agreed to the vendor & his purposes)
							if (consentStatus === true) {
								// Loop into all the ".youtube-container" (even if we only have one in the example)
								document.querySelectorAll('.youtube-container').forEach(function(video) {
									// call our play & hide function
									playVideoAndHideOverlay(video);
								})
							}
							else {
								hidePlayerVideo();
							}
						})

						// An event listener is attached to each button element
						document.querySelectorAll('.video-consent-overlay-accept-button').forEach(function(button) {
							button.addEventListener('click', function() {
								// When the button is clicked, we call the setPositiveConsentStatusForVendor custom function to enable the vendor (Youtube) and all his purposes.
								setPositiveConsentStatusForVendor('c:youtube-xhBVKfkq');
							})
						})
					});
				}	
			}
		};
	})();

// Update global scope lq namespace
window.lq = lq;

// Auto trigger all self implemented (plugin) functionalities
lq.load.push(
	"lq.video",
	[
		'loadDidomi'
	]
);

}(jQuery, document, window, (window.lq || {})));
